import { apiSahSuppliers } from '~constants/api';

import { get, patch, post, put } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

export const typePrefix = `suppliers`;

const config = [
  { actionType: 'getAll', apiPath: apiSahSuppliers, method: get },
  { actionType: 'createSupplier', apiPath: apiSahSuppliers, method: post },
  { actionType: 'updateSupplier', apiPath: (params: Params) => `${apiSahSuppliers}/${params.id}`, method: put },
  { actionType: 'deleteSupplier', apiPath: (params: Params) => `${apiSahSuppliers}/${params.id}`, method: patch },
];

export const { getAll, createSupplier, updateSupplier, deleteSupplier } = createThunks(typePrefix, config);
